export default {
  namespaced: true,
  custom_forms: {
    select_tenant: "Select a tenant",
    select_user: "Select a user",
    select_user_group: "Select user groups",
    select_users: "Select users",
    select_facility: "Select facility",
    select_facility_category: "Select facility category",
    select_related_forms: "Select related forms",
    prefill_template: "Is prefill template",
    requires_prefill: "Requires Prefill",
    is_mailable: "Is Mailable",
    display_in_alarm: "Display in alarm manu",
    is_horizontal: "Display the form horizontally",
    is_cheker_maker: "Requires approval",
    allow_draft: "Allow saving draft",
    types: {
      title: 'type | types',
      select: "Select",
      checkbox: "Checkbox",
      text_answer: "Text Answer",
      files_section: "Files Section",
      commands: "Commands",
      inputGroup: "Input group",
      inputText: "Input text",
      users: "User",
      rh_users: "Rh Users",
      units: "Unit",
      facilities: "Facility",
      placeholder: "Placeholder",
      facility_category: "Facility category",
      date: "Date",
      time: "Time",
      minutes: "Minutes",
      time_hhmm: "Time (HH:MM)",
      duration_hm: "Duration (hours and minutes)",
      duration_ms: "Duration (minutes and seconds)",
      duration_hms: "Duration (hours, minutes and seconds)",
      numeric: "Numeric",
      classification: "Classification",
      distribution_lists: "Distribution lists",
      recipient: "Recipient",
      subject: "Subject",
      email: "Email",
      related_forms: "Related forms",
      local_time: "Local time",
      central_time: "Central Time",
      user_list: "User list",
      keyword: "Keyword",
      folio: "Folio",
      region: "Region",
      timestamp: "Timestamp",
      device_doc: "Device documentation",
      supplier: "Supplier",
      technicians: "Technicians",
    },
    allow_comment: "Allow comment",
    select_multiple: "Select Multiple",
    selecting_multiple: "Selecting...",
    clean: "Clean",
    send_to_review: "Send to Review",
    reopen: "Reopen form",
    state: "State",
    user: "User",
    user_group: "User group",
    date: "Date",
    note: "Note",
    empty: "No entries",
    show_less: "Show less",
    show_all: "Show full history",
    btn_reassign: "Reassign",
    close: "Close",
    entries: "Entries",
    history: "History",
    select_reviewer: "Select reviewer",
    cannot_start_form: "Cannot start form",
    update_state_error: "Cannot update state",
    answers_saved: "Answers saved",
    reassign: "Reassign",
    select_reassigner: "Select reassigner",
    assigned_to: "Assign responsible person",
    assigned_to_reopen: "Assign person responsible for reopening",
    reassigned_to: "Reasigned responsible",
    review_comments: "Review comments",
    content: "Content",
    placeholder_tooltip: "will be replaced with real values when sent.",
    generate_keyword: "Generate Keyword",
    maxlength: "Maximum number of characters.",
    maxlengthSelect: "Maximum number of items to select",
    hint: "Hint.",
    date_format: "Date Format",
    generate_timestamp: "Click to generate timestamp",
    check_facility_fields: "Check which extra fields should appear",
    categories: "Categories",
    subregion: "Subregion",
    id_seproban: "ID SEPROBAN",
    municipality: "Municipality",
    region_field: "Region",
    sirh: "SIRH",
    rems: "REMS",
    read_only: "Read only",
    maximun_amount: "Maximum amount you can select",
    type_number: "Type number",
    no_extra_config: "No extra configuration for this field type",
    lat: "Latitude",
    lng: "Length",
    read_only_users: "Read only users",
    only_img: "Only images",
    show_empty: "Show empty",
    read_only_users: "Read only users",
    significant_event: "Significant event",
    significant_event_title: "Event title",
    significant_event_description: "Event description",
    significant_event_regional_manager: "Acting security manager",
    security_manager: "Security manager",
    excluded_atms: "Exclude ATMs",
  }
}
